export default __webpack_public_path__ + "static/media/bannerr5.7d338bd9.webp";